import { ReactNode } from 'react'

import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

export interface ClaimsPageContent {
  hero: NarrativeHeroProps
  claimsProcess: {
    title: string
    steps: {
      title: string
      description: string
    }[]
  }
  claimsForms: {
    title: string
    forms: {
      name: string
      href: string
    }[]
  }
  contactInfo: {
    title: string
    sections: {
      title: string
      content: (ReactNode | string)[]
    }[]
  }
}

const hero: NarrativeHeroProps = {
  header: 'ShipSticks Claims Process',
  subHeader:
    'Learn about our claims process and file a claim for damaged, lost, or delayed shipments.',
}

const claimsProcess = {
  title: 'Claims Process',
  steps: [
    {
      title: 'File Claim',
      description:
        'To begin the claims process you will select the appropriate online form below and ' +
        'fill out all required fields. All claims must be filed within 10 days of the ' +
        'actual or scheduled delivery date.',
    },
    {
      title: 'Claim Reviewed',
      description:
        'A claims specialist will review and file your claim within 1-2 business days. ' +
        'If additional information is needed, a claims specialist will contact you by ' +
        'phone or email.',
    },
    {
      title: 'Claim Filed',
      description:
        'Once your claim has been filed you can expect to receive an update on your claim ' +
        'within 7-10 business days. At this time we will notify you if your claim has ' +
        'been approved.',
    },
    {
      title: 'Claim Approved',
      description:
        'Once your claim has been approved we will mail your reimbursement check via USPS. ' +
        'The check will be sent to the address provided in your claims submission.',
    },
  ],
}

const claimsForms = {
  title: 'ShipSticks Claims',
  forms: [
    {
      name: 'Damaged/Missing Items Claim Form',
      href: '/form/damaged_missing_items_form',
    },
    {
      name: 'Shipment Protection Claim Form',
      href: '/form/shipment_protection_form',
    },
  ],
}

const contactInfo = {
  title: 'Contact Claims at ShipSticks',
  sections: [
    {
      title: 'Claims Department',
      content: [
        'Email: info@shipsticks.com',
        'Phone: (561) 429-3900',
        'Hours: Monday - Friday, 9:00 AM - 6:00 PM EST',
      ],
    },
    {
      title: 'Mailing Address',
      content: [
        'ShipSticks Claims Department',
        '1140 N. Jog Road Suite 300',
        'Palm Beach Gardens, FL 33418',
      ],
    },
  ],
}

const content: ClaimsPageContent = {
  hero,
  claimsProcess,
  claimsForms,
  contactInfo,
}

export default content
